import { useTransport } from "@/lib/transport";

export function AboutSettings() {
  const transport = useTransport();
  const isStudio = transport.mode === "studio";

  return (
    <div>
      <div style={{ fontSize: "var(--text-lg)", fontWeight: "var(--weight-bold)", color: "var(--text-primary)", marginBottom: "var(--space-6)" }}>
        About StreamPersona
      </div>

      <div style={{
        padding: "var(--space-6)",
        background: "var(--bg-raised)",
        borderRadius: "var(--radius-xl)",
        border: "1px solid var(--border-subtle)",
        marginBottom: "var(--space-6)",
      }}>
        <div style={{ display: "flex", alignItems: "center", gap: "var(--space-4)", marginBottom: "var(--space-5)" }}>
          <div style={{
            width: 48, height: 48, borderRadius: "var(--radius-lg)",
            background: "linear-gradient(135deg, #00d4aa 0%, #00b4d8 100%)",
            display: "flex", alignItems: "center", justifyContent: "center",
            fontSize: 22, fontWeight: "var(--weight-bold)", color: "#000",
            boxShadow: "0 4px 14px rgba(0, 212, 170, 0.35)",
          }}>
            S
          </div>
          <div>
            <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
              <span style={{ fontSize: "var(--text-lg)", fontWeight: "var(--weight-bold)", color: "var(--text-primary)" }}>
                {isStudio ? "StreamPersona Studio" : "StreamPersona Lite"}
              </span>
              <span style={{
                fontSize: "10px",
                fontWeight: 700,
                textTransform: "uppercase",
                letterSpacing: "0.06em",
                background: isStudio ? "rgba(245, 158, 11, 0.15)" : "rgba(0, 212, 170, 0.15)",
                color: isStudio ? "#fbbf24" : "var(--accent)",
                padding: "2px 8px",
                borderRadius: "var(--radius-sm)",
                border: isStudio ? "1px solid rgba(245, 158, 11, 0.3)" : "1px solid var(--accent-glow)",
              }}>
                {isStudio ? "Workstation Beta" : "v0.1.0 Production"}
              </span>
            </div>
            <div style={{ fontSize: "var(--text-sm)", color: "var(--text-muted)", marginTop: "2px" }}>
              {isStudio
                ? "Dedicated Workstation · Local Neural Inference & Voice Synthesis"
                : "Cloud Accelerated · Zero-Inbound Neural Visual Synthesis"}
            </div>
          </div>
        </div>

        <div style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
          gap: "var(--space-3)",
          marginTop: "var(--space-4)",
          paddingTop: "var(--space-4)",
          borderTop: "1px solid var(--border-subtle)",
        }}>
          {isStudio ? (
            <>
              <SpecItem label="Inference Engine" value="Local CUDA / TensorRT Engine" />
              <SpecItem label="Neural Pipelines" value="DeepLiveCam + Chatterbox Turbo" />
              <SpecItem label="Audio Architecture" value="Local VB-Cable / OBS Loopback" />
              <SpecItem label="Target Environment" value="Workstation (NVIDIA RTX 4080 / 4090 / 5090)" />
            </>
          ) : (
            <>
              <SpecItem label="Cloud Acceleration" value="NVIDIA GeForce RTX 5090 (Blackwell 32GB)" />
              <SpecItem label="Network Protocol" value="LiveKit Cloud WebRTC DataPlane" />
              <SpecItem label="Transit Latency" value="Sub-30ms Peer-to-Peer Loopback" />
              <SpecItem label="Local Footprint" value="Zero Python Dependencies (<20MB Client)" />
            </>
          )}
        </div>
      </div>

      <div style={{
        padding: "var(--space-4)",
        background: "var(--bg-overlay)",
        borderRadius: "var(--radius-lg)",
        border: "1px solid var(--border-subtle)",
        fontSize: "var(--text-xs)",
        color: "var(--text-muted)",
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}>
        <span>© 2026 StreamPersona Inc. All rights reserved.</span>
        <span>Built with Tauri &amp; React</span>
      </div>
    </div>
  );
}

function SpecItem({ label, value }: { label: string; value: string }) {
  return (
    <div style={{
      padding: "10px 12px",
      background: "var(--bg-surface)",
      borderRadius: "var(--radius-md)",
      border: "1px solid var(--border-subtle)",
    }}>
      <div style={{ fontSize: "11px", color: "var(--text-muted)", textTransform: "uppercase", letterSpacing: "0.05em", fontWeight: 600 }}>
        {label}
      </div>
      <div style={{ fontSize: "13px", color: "var(--text-primary)", fontWeight: 500, marginTop: "3px" }}>
        {value}
      </div>
    </div>
  );
}
